export default {
    CIS: "CIS",
    HDL: "HDL",
        
}


// WEBPACK FOOTER //
// ./src/constants/DesignEntryTypes.js